<script setup lang="ts">
import { Vue3Lottie } from 'vue3-lottie';
import LoadingIndicator from '@/assets/animations/LoadingIndicator.json';
import { onBeforeUnmount, useTemplateRef } from 'vue';

withDefaults(
  defineProps<{
    show: boolean;
    size?: number;
    dim?: boolean;
    rounded?: boolean;
    zIndex?: number;
  }>(),
  {
    size: 48,
    dim: true,
    rounded: true,
    zIndex: 10,
  },
);

const lottieRef = useTemplateRef('lottie');

onBeforeUnmount(() => {
  lottieRef.value?.stop();
  lottieRef.value?.destroy();
});
</script>

<template>
  <!-- Parent should be position relative! -->
  <div v-if="show" class="absolute inset-0 flex items-center justify-center" :style="{ zIndex }">
    <div
      :class="['absolute inset-0', dim ? 'bg-surface-secondary/50' : 'bg-transparent', rounded ? 'rounded-2xl' : '']"
    />
    <Vue3Lottie
      ref="lottie"
      :animation-data="LoadingIndicator"
      :loop="true"
      :autoplay="true"
      :renderer-settings="{ preserveAspectRatio: 'xMidYMid meet' }"
      :height="size"
      :width="size"
      class="relative pointer-events-none"
    />
  </div>
</template>
